var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AxiosError } from "axios";
import { takeEvery, call, put, getContext } from "redux-saga/effects";
import { Dashboard } from "../constants/dashboard";
import { APIType } from "../services/authenticationService";
function getFields(actions) {
    var callAPI, response, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_c.sent()).callAPI;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 9]);
                return [4 /*yield*/, call(function () {
                        // return callAPI(APIType.GET, "/api/get_fields/");
                        return callAPI(APIType.GET, "/api/get_fields_for_user/", {
                            params: { user: actions.username },
                        });
                    })];
            case 3:
                response = _c.sent();
                if (!response) return [3 /*break*/, 5];
                // Detailed logging of API response for debugging
                console.group("API Response Details for get_fields_for_user");
                console.log("API Response:", response.data);
                // Check if key fields exist
                console.log("Checking for obligation data fields:");
                console.log("Has 'Client obligations data':", !!response.data["Client obligations data"]);
                console.log("Has 'Adviser obligations data':", !!response.data["Adviser obligations data"]);
                console.log("Has 'Adviser client obligations data':", !!response.data["Adviser client obligations data"]);
                console.log("Has 'Adviser adviser obligations data':", !!response.data["Adviser adviser obligations data"]);
                // Count the number of obligations
                console.log("Data counts:");
                if (response.data["Client obligations data"]) {
                    console.log("Client obligations count:", Object.keys(response.data["Client obligations data"]).length);
                }
                if (response.data["Adviser obligations data"]) {
                    console.log("Adviser obligations count:", Object.keys(response.data["Adviser obligations data"]).length);
                }
                if (response.data["Adviser client obligations data"]) {
                    console.log("Adviser client obligations count:", Object.keys(response.data["Adviser client obligations data"]).length);
                }
                if (response.data["Adviser adviser obligations data"]) {
                    console.log("Adviser adviser obligations count:", Object.keys(response.data["Adviser adviser obligations data"]).length);
                }
                console.groupEnd();
                return [4 /*yield*/, put({
                        type: Dashboard.Stats_Tiles_Successful,
                        payload: response.data,
                    })];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 9];
            case 6:
                error_1 = _c.sent();
                if (!(error_1 instanceof AxiosError)) return [3 /*break*/, 8];
                if (!(((_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status) === 404 || ((_b = error_1.response) === null || _b === void 0 ? void 0 : _b.status) === 404)) return [3 /*break*/, 8];
                return [4 /*yield*/, put({
                        type: Dashboard.Stats_Tiles_Empty,
                    })];
            case 7:
                _c.sent();
                return [2 /*return*/];
            case 8:
                // Log any error that occurs during API call
                console.error("Error fetching dashboard data:", error_1);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getQuesAttemptDetails(actions) {
    var callAPI, username, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                username = actions.username;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.GET, "/api/router/jobseekers/by_username/?username=".concat(username));
                    })];
            case 3:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: Dashboard.Ques_Attempt_Details_Successful,
                        payload: response.data[0],
                    })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_2 = _a.sent();
                return [4 /*yield*/, put({
                        type: Dashboard.Ques_Attempt_Details_Error,
                        payload: error_2,
                    })];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getAdvierInfo() {
    var callAPI, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.GET, "/api/get_hierarchy/");
                    })];
            case 3:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: Dashboard.Adviser_Info_Successful,
                        payload: response.data,
                    })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_3 = _a.sent();
                return [4 /*yield*/, put({
                        type: Dashboard.Adviser_Info_Error,
                        payload: error_3,
                    })];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateQuesAttemptDetails(actions) {
    var callAPI, username, second_attempt, response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_a.sent()).callAPI;
                username = actions.data.username;
                second_attempt = {
                    second_attempt_ready: actions.toggle,
                };
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.PUT, "/api/jobseekers/".concat(username, "/"), {
                            body: second_attempt,
                        });
                    })];
            case 3:
                response = _a.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: Dashboard.Update_Ques_Attempt_Details_Successful,
                        payload: response.data,
                    })];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_4 = _a.sent();
                return [4 /*yield*/, put({
                        type: Dashboard.Update_Ques_Attempt_Details_Error,
                        payload: error_4,
                    })];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export default function DashboardSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(Dashboard.Stats_Tiles, getFields)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(Dashboard.Ques_Attempt_Details, getQuesAttemptDetails)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(Dashboard.Adviser_Info, getAdvierInfo)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(Dashboard.Update_Ques_Attempt_Details, updateQuesAttemptDetails)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
